import moment from "moment";
import React from "react";
import { ButtonToolbar } from "react-bootstrap";
import { RangePicker } from "../../widgets";

function ButtonToolbarRangePicker(props) {
  const {
    handleDatesChange, fromDate, toDate, monthsToDisplay = 1,
  } = props;
  return (
    <ButtonToolbar>
      <RangePicker
        startDate={moment(new Date(fromDate))}
        endDate={moment(new Date(toDate))}
        monthsToDisplay={monthsToDisplay}
        onDatesChange={handleDatesChange}
      />
    </ButtonToolbar>
  );
}

export default ButtonToolbarRangePicker;
